export const _myInfo = {
  userInfo: {
    email: "adamhereforwork@gmail.com",
    fullName: "Jose Luis Bobadilla Sanchez",
    role: "Senior Full Stack Developer",
    website: "https://www.jperfectsolution.web.app",
    linkedin: "https://www.linkedin.com/in/jose-bobadilla-12389319b/",
    github: "https://github.com/JPerfectSolution",
    cv: "CV_Luis.pdf",
    city: "Oita",
    address: "Oita, Japan",
    birthday: new Date(1991, 6, 3),
    interests: "Freelancing, Soccer, UFC",
    graduatedSchool: "Serbias Technical College",
    degree: "Bachelor(Software Engineering)",
  },
  summary:
    "I'm very passionate and dedicated to my work. With 10+ years experience as a professional Web developer, I have acquired the skills and knowledge necessary to make your project a success. I enjoy every step of the design process, from discussion and collaboration to concept and execution, but I find the most satisfaction in seeing the finished product do everything for you that it was created to do.",
  skillDescription:
    "I am a passionate, experienced, entrepreneurial, hands-on professional with 10+ years of experience, solving business challenges through the successful design and implementation of technology. Specifically, I have long been focusing on responsive web / mobile frontend development with React, Angular, Vue, React Native, Ionic, ES6/7, TypeScript, HTML5, CSS3, Bootstrap, SASS/LESS, StyledComponents, Storyblok, Contentful, Netlify Material-UI, Semantic-UI, etc. Talking about technical skills, I primarily work with the following development stack:",
  skills: [
    {
      skill: "Angular/Ionic/Universal",
      years: new Date(2015, 1, 1),
      level: 95,
    },
    {
      skill: "React/Redux/Next/Gatsby",
      years: new Date(2014, 1, 1),
      level: 90,
    },
    { skill: "Vue/Vuex/Nuxt", years: new Date(2018, 1, 1), level: 90 },
    { skill: "JavaScript", years: new Date(2009, 1, 1), level: 99 },
    { skill: "HTML/CSS/SCSS", years: new Date(2009, 1, 1), level: 100 },
    { skill: "Node/Express", years: new Date(2012, 1, 1), level: 95 },
    { skill: "Database", years: new Date(2012, 1, 1), level: 85 },
  ],
  skillsMore: [
    {
      skill: "PHP/Laravel/ZendFrameworks/Yii",
      years: new Date(2015, 1, 1),
      level: 90,
    },
    {
      skill: "Python/Django/Flask",
      years: new Date(2014, 1, 1),
      level: 80,
    },
    {
      skill: "Ruby/Ruby on Rails",
      years: new Date(2018, 1, 1),
      level: 70,
    },
    { skill: "C/C++", years: new Date(2009, 1, 1), level: 95 },
    { skill: "Embedded Linux", years: new Date(2009, 1, 1), level: 75 },
  ],
  services: [
    {
      title: "Front-End Development",
      icon: "fas fa-drafting-compass",
      content: [
        "AngularJS, Angular 6+, Ionic, Angular PWA, Angular Universal",
        "React, NextJS, Gatsby, Redux, Mobx",
        "Vue, Vuex, Vuetify, Vue Material",
        "Electron Application with Angular, React, Vue",
        "Bootstrap, Material UI, Kendo UI, Syncfusion",
      ],
    },
    {
      title: "Back-End Development",
      icon: "fas fa-hiking",
      content: [
        "NodeJS, ExpressJS, NestJS, Sails.js, Hapi.js, Strapi.io",
        "PHP, Laravel, ZendFramework2, Codeignitor",
        "Ruby, Ruby on Rails",
        "C#, ASP.NET Frameworks, ASP.NET Core",
        "PostgreSQL, MongoDB, MySQL, SQLite, MS SQL",
      ],
    },
    {
      title: "Others",
      icon: "fas fa-feather-alt",
      content: [
        "Contentful CMS, Netlify, StoryBlok, Netlify, SiteCore",
        "Google Cloud, Firebase, AWS, Azure",
        "Payment, Social Integration, 3rd Party Library Integration",
        "Github, Bitbucket, Gitlab, SVN, Jira, Trello, Asana",
        "Code Standard: AirBnb",
      ],
    },
  ],

  category: ["All", "Frontend", "Backend", "Full-Stack"],
  works: [
    {
      category: ["Frontend", "Full-Stack"],
      title: "DAMAC",
      imgUrl: "assets/works/4_damac.png",
      url: "http://damac-graphql.s3-website-us-east-1.amazonaws.com/en/",
      skills: [
        "React",
        "Gatsby",
        "Redux",
        "Responsive Design",
        "i18n",
        "GraphQL",
      ],
    },
    {
      category: ["Frontend"],
      title: "Cost Certified",
      imgUrl: "assets/works/2_costcertified.png",
      url: "http://costcertified.com/",
      skills: ["Vue", "Vuex", "Nuxt", "Contentful CMS", "Responsive Design"],
    },
    {
      category: ["Backend", "Full-Stack"],
      title: "brandnooz",
      imgUrl: "assets/works/7_brandnooz.png",
      url: "https://www.brandnooz.de/",
      skills: [
        "Ruby",
        "Ruby on Rails 5",
        "PostgreSQL",
        "Google Cloud API",
        "Payment Integration",
      ],
    },
    {
      category: ["Frontend", "Full-Stack"],
      title: "Songyfty",
      imgUrl: "assets/works/3_songyft.png",
      url: "https://app.songyft.com/",
      skills: ["Angular 9", "Ionic 4", "Angular PWA", "Google Tag Manager", ""],
    },
    {
      category: ["Frontend"],
      imgUrl: "assets/works/0_fevo.png",
      title: "Fevo",
      url: "https://www.fevo.com/",
      skills: ["React", "Redux", "Bootstrap", "UX"],
    },
    {
      category: ["Frontend"],
      title: "GREEN CHALK",
      imgUrl: "assets/works/15_green_chalk.png",
      url: "http://uat.greenchalk.in/landing",
      skills: ["Angular", "Firebase", "Google Maps", "Twillio"],
    },
    {
      category: ["Frontend", "Backend"],
      title: "GREEN CHALK ADMIN",
      imgUrl: "assets/works/14_greenchalk_admin.png",
      url: "http://uat.admin.greenchalk.in/login",
      skills: [
        "Angular",
        "Firebase",
        "D3",
        "Firebase",
        "Google Maps",
        "Payment Integration",
      ],
    },
    {
      category: ["Backend", "Full-Stack"],
      title: "Brandnooz Admin",
      imgUrl: "assets/works/13_brandnooz_admin.png",
      url: "https://admin.brandnooz.de/",
      skills: [
        "Ruby",
        "Ruby on Rails 5",
        "PostgreSQL",
        "Google Cloud API",
        "Payment Integration",
      ],
    },
    {
      category: ["Frontend"],
      imgUrl: "assets/works/1_artist.png",
      title: "Artist: Peterson Brothers Band",
      url: "https://www.petersonbrothersband.com/",
      skills: ["React", "Redux", "Bootstrap", "UX"],
    },
    {
      category: ["Frontend", "Full-Stack"],
      title: "Local Insignts",
      imgUrl: "assets/works/6_localinsignts.png",
      url: "https://localinsights.io/",
      skills: ["React", "Next", "Webpack", "Google Cloud"],
    },
    {
      category: ["Frontend", "Full-Stack"],
      title: "Taxi Deals",
      imgUrl: "assets/works/5_taxideals.png",
      url: "https://taxideals.ch",
      skills: ["Vue", "Vuex", "Nuxt", "Contentful CMS", "Responsive Design"],
    },
    {
      category: ["Backend"],
      title: "Pacific Printing",
      imgUrl: "assets/works/12_pacific_printing.png",
      url: "http://www.pacificprintingak.com/",
      skills: [
        "Node",
        "Express",
        "MailChimp",
        "Bootstrap",
        "jQuery",
        "SnipCart",
      ],
    },
    {
      category: ["Frontend"],
      title: "SOLD",
      imgUrl: "assets/works/8_sold.png",
      url: "https://www.sold.com/",
      skills: ["React", "Next", "Redux"],
    },
    {
      category: ["Frontend"],
      title: "Blu Flamingo",
      imgUrl: "assets/works/11_blumingo.png",
      url: "https://gracious-swartz-938141.netlify.app/",
      skills: ["React", "Gatsby", "Responsive Design"],
    },
    {
      category: ["Frontend", "Full-Stack"],
      title: "One Model Place",
      imgUrl: "assets/works/10_onemodelplace.png",
      url: "https://www.onemodelplace.com",
      skills: ["AngularJS", "FreshChat", "Facebook Widget"],
    },
    {
      category: ["Frontend"],
      title: "Beatstars",
      imgUrl: "assets/works/9_beatstars.png",
      url: "https://www.beatstars.com/",
      skills: ["Angular", "Stripe 3", "Material UI"],
    },
  ],
};
